import * as React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { ErrorAlert } from '~/UI';
import { ErrorConsumer } from '~/ErrorHandler';
import { Gdpr } from '~/Password';
export var GdprConsent = function () {
    return (<Grid style={{ height: '100vh' }} textAlign='center' verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
				<Header>GDPR</Header>
				<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
				<Gdpr />
			</Grid.Column>
		</Grid>);
};
